import { Participation_Messages } from './survey-messages';
import { ContactRules, PrePopDetails } from './questions';
import { ParticipationResponseData, ResponseData } from './response-data';
import { DirQuestionPiping } from './directory-linking';

export class SurveySpecificData {
    PrePopDetails: PrePopDetails[];
    Participation_Message_Type: number;
    Participation_Messages:Participation_Messages;
    ParticipationResponseData :ParticipationResponseData;
    GeoLocation: string;
    contactRules : ContactRules[];

}
